import React from "react";
const CreativesGridContext = React.createContext();
export default CreativesGridContext;